// extracted by mini-css-extract-plugin
export var content = "_98-3";
export var list = "_98-4";
export var settingsContent = "_98-7";
export var settingsPanel = "_98-8";
export var state = "_98-6";
export var triggerBadge = "_98-2";
export var triggerButton = "_98-1";
export var triggerShell = "_98-0";
export var unreadDot = "_98-5";